import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
export const metadata = {
  title: "AI Subagents",
  published_at: "2026-02-09",
  summary: "The AI assistant can now dive deep into your pursuits and documents on demand, searching across files and exploring details without leaving your chat.",
  tags: ["AI", "Pursuit"],
  draft: false
};
export const sections = [];
function _createMdxContent(props) {
  const _components = {
    li: "li",
    p: "p",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {ChangelogVideo} = _components;
  if (!ChangelogVideo) _missingMdxReference("ChangelogVideo", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "The AI assistant now works with specialized subagents that can explore your pursuits and files in depth. Ask a question about a specific pursuit, and a dedicated pursuit explorer searches through its requirements, compliance details, and documents to bring back exactly what you need — with citations linked to the source. The same works for files: ask \"what are the security requirements in that RFP?\" and a file explorer digs through the document to find the answer."
    }), "\n", _jsx(ChangelogVideo, {
      mediaId: "9eea532e-ade2-5ec2-9726-9bdfd7955cae"
    }), "\n", _jsx(_components.p, {
      children: "This means you can go deeper into search results without ever leaving your conversation. Found an interesting pursuit in a search? Ask a follow-up question and the AI handles the rest, pulling in relevant details from across your documents and pursuits."
    }), "\n", _jsxs("details", {
      children: [_jsx("summary", {
        children: "AI (6)"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Follow-up question suggestions after AI responses"
        }), "\n", _jsx(_components.li, {
          children: "New starter prompts for fresh conversations"
        }), "\n", _jsx(_components.li, {
          children: "AI reports support longer documents with more detailed output"
        }), "\n", _jsx(_components.li, {
          children: "Improved accuracy of AI-generated results"
        }), "\n", _jsx(_components.li, {
          children: "Fixed images not displaying correctly in AI responses"
        }), "\n", _jsx(_components.li, {
          children: "Fixed knowledge base source links sometimes pointing to wrong sections"
        }), "\n"]
      })]
    }), "\n", _jsxs("details", {
      children: [_jsx("summary", {
        children: "UX (6)"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Search and Replace in the proposal editor for finding and replacing text across your document"
        }), "\n", _jsx(_components.li, {
          children: "Tag filters are now sorted alphabetically for easier browsing"
        }), "\n", _jsx(_components.li, {
          children: "Tags display a preview of their contents on hover"
        }), "\n", _jsx(_components.li, {
          children: "Simplified team invitation flow with fewer steps"
        }), "\n", _jsx(_components.li, {
          children: "New starter pricing tier for smaller teams"
        }), "\n", _jsx(_components.li, {
          children: "Fixed duplicate user entries appearing in team management"
        }), "\n"]
      })]
    }), "\n", _jsxs("details", {
      children: [_jsx("summary", {
        children: "Reliability (5)"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Fixed occasional gaps in AI-generated results"
        }), "\n", _jsx(_components.li, {
          children: "Fixed an error when the AI assistant accessed certain pursuit data"
        }), "\n", _jsx(_components.li, {
          children: "Fixed deleted files still showing in company profiles"
        }), "\n", _jsx(_components.li, {
          children: "Fixed document conversion failures on certain file types"
        }), "\n", _jsx(_components.li, {
          children: "Fixed proposal outline tool not saving changes in some cases"
        }), "\n"]
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
